(function () {
  function setup() {
    var list = document.querySelector('ul[id^=Slider-Gallery-]');
    if (!list || list.getAttribute('data-dots')) return;
    var slides = list.querySelectorAll('.product__media-item');
    if (slides.length < 2) return;
    list.setAttribute('data-dots', '1');

    var box = document.createElement('div');
    box.className = 'mg-dots';
    var dots = [];

    function go(i) {
      var left = list.getBoundingClientRect().left;
      list.scrollTo({ left: list.scrollLeft + slides[i].getBoundingClientRect().left - left, behavior: 'smooth' });
    }

    function update() {
      var left = list.getBoundingClientRect().left, best = 0, min = 1e9;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slides[i].getBoundingClientRect().left - left);
        if (d < min) { min = d; best = i; }
      }
      for (var j = 0; j < dots.length; j++) {
        dots[j].className = j === best ? 'is-active' : '';
      }
    }

    for (var i = 0; i < slides.length; i++) {
      (function (i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Show image ' + (i + 1));
        b.addEventListener('click', function () { go(i); });
        box.appendChild(b);
        dots.push(b);
      })(i);
    }

    list.parentNode.appendChild(box);
    list.addEventListener('scroll', update, { passive: true });
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
